export const PERMISSION_LABELS: Record<string, string> = {
  "pos.view": "Ver POS",
  "sales.create": "Crear ventas",
  "sales.void": "Anular ventas",
  "invoice.reprint": "Reimprimir factura",
  "discounts.apply": "Aplicar descuentos",
  "products.create": "Crear productos",
  "products.edit": "Editar productos",
  "inventory.view": "Ver inventario",
  "inventory.edit": "Editar inventario",
  "cost.view": "Ver precios de costo",
  "customers.create": "Crear clientes",
  "customers.edit": "Editar clientes",
  "invoices.edit": "Editar facturas",
  "refunds.create": "Hacer reembolsos",
  "cash.view": "Ver cuadres",
  "cash.close": "Cerrar caja",
  "users.manage": "Administrar usuarios",
  "branches.manage": "Administrar sucursales",
  "settings.manage": "Configurar sistema",
  "audit.view": "Consultar auditoría",
  "profit.view": "Ver ganancias",
};

export interface PermissionGroup {
  title: string;
  icon: string;
  codes: string[];
}

export const PERMISSION_GROUPS: PermissionGroup[] = [
  {
    title: "Punto de venta y ventas",
    icon: "ri-store-2-line",
    codes: ["pos.view", "sales.create", "sales.void", "invoice.reprint", "discounts.apply"],
  },
  {
    title: "Productos e inventario",
    icon: "ri-stack-line",
    codes: ["products.create", "products.edit", "inventory.view", "inventory.edit", "cost.view"],
  },
  {
    title: "Clientes",
    icon: "ri-user-3-line",
    codes: ["customers.create", "customers.edit"],
  },
  {
    title: "Facturación y caja",
    icon: "ri-receipt-line",
    codes: ["invoices.edit", "refunds.create", "cash.view", "cash.close"],
  },
  {
    title: "Administración",
    icon: "ri-settings-3-line",
    codes: ["users.manage", "branches.manage", "settings.manage", "audit.view", "profit.view"],
  },
];

export const ALL_PERMISSION_CODES = PERMISSION_GROUPS.flatMap((group) => group.codes);

/** Sensible default set for a new cashier. */
export const DEFAULT_CASHIER_PERMISSIONS = [
  "pos.view",
  "sales.create",
  "invoice.reprint",
  "customers.create",
  "customers.edit",
  "inventory.view",
];